module.exports = "/images/procedures-in-progress.5e032b85cc34f97f38ddc98ecd0a2bc5.svg";